<script async lang="ts" setup>
import { inject, ref, watch } from 'vue'
import { useApi } from '@/store/useAppStore'
import UserApi from '@/services/api/core/UserApi'
import { store } from '@/store/store'

import { Database } from '@/models/database/Database'

interface Props {
  database: Database
  node: Node
  // field: Field;
}

const props = withDefaults(defineProps<Props>(), {})

const userApi: UserApi = useApi()

console.log('store', store.state)

const treeRef = inject('treeRef')

let gdprProjectId = ref(undefined)

const rows = ref([])

const columns = [
  {
    name: 'domain',
    required: true,
    label: 'Domaine',
    align: 'left',
    field: 'domain',
    sortable: true,
  },
  {
    name: 'treatment',
    align: 'left',
    label: 'Traitement',
    field: 'treatment',
    sortable: true,
  },
  {
    name: 'finality',
    align: 'left',
    label: 'Finalité',
    field: 'finality',
    sortable: true,
  },
  {
    name: 'date',
    required: true,
    label: 'Date',
    align: 'left',
    field: 'date',
    sortable: true,
  },
  {
    name: 'taskLink',
    align: 'left',
    label: 'Tâche',
    field: 'taskLink',
    sortable: true,
  },
  {
    name: 'surveySummaryLink',
    align: 'left',
    label: 'Fiche',
    field: 'surveySummaryLink',
    sortable: true,
  },
]

let children = []
const loading = ref(false)

async function update() {
  console.log('props.node', props.node)
  console.log('treeRef', treeRef)
  const parentNode = treeRef.value.getNodeByKey(props.node.parentId)
  console.log('parentNode', parentNode)
  if (parentNode != null) {
    if (parentNode.fields.length > 0) {
      gdprProjectId.value = parentNode.fields[0].value
    }
  } else {
    console.log('parent node not found')
  }

  if (gdprProjectId.value == null || gdprProjectId.value == undefined) {
    return
  }

  loading.value = true

  let requests = undefined
  children = []

  try {
    requests = await userApi.getAllTreatmentRegister(gdprProjectId.value)
  } catch (error) {
    console.log(error)
    // gdprProjectId.value = undefined;
    loading.value = false
    rows.value = []
    return
  }

  requests.items.forEach((request) => {
    console.log('request', request)
    children.push({
      fields: [
        {
          name: 'domain',
          value: request.domain,
        },
        {
          name: 'treatment',
          value: request.treatment,
        },
        {
          name: 'date',
          value: request.date,
        },
        {
          name: 'finality',
          value: request.finality,
        },
        {
          name: 'taskLink',
          value: request.taskLink,
        },
        {
          name: 'surveySummaryLink',
          value: request.surveySummaryLink,
        },
      ],
    })
  })

  rows.value = []
  var id = 0
  children?.forEach((child) => {
    rows.value.push({
      id: id++,
      domain: child.fields[0].value,
      treatment: child.fields[1].value,
      date: child.fields[2].value,
      finality: child.fields[3].value,
      taskLink: child.fields[4].value,
      surveySummaryLink: child.fields[5].value,
    })
  })

  loading.value = false
}

const pagination = ref({
  rowsPerPage: 0,
})

watch(
  () => props.node,
  () => {
    update()
  },
)

update()
</script>

<template>
  <suspense>
    <q-card flat bordered>
      <q-card-section class="row">
        <span class="text-h6">RGPD - Registre des traitements</span>
        <q-space />
        <q-icon name="update" size="sm" class="cursor-pointer" clickable @click="update()" />
        <!-- icon directory-sync -->
        &nbsp;&nbsp;&nbsp;
      </q-card-section>

      <q-card-section class="q-pt-none">
        <div v-if="gdprProjectId == null || gdprProjectId == undefined">
          Aucun projet juridique sélectionné dans le noeuds "Registres RGPD"
        </div>
        <q-table
          v-if="gdprProjectId != null && gdprProjectId != undefined"
          :rows="rows"
          :columns="columns"
          row-key="id"
          :loading="loading"
          :rows-per-page-options="[0]"
          :pagination="pagination"
          class=""
        >
          <template v-slot:body-cell-domain="props">
            <q-td :props="props">
              <div style="overflow-wrap: normal; word-break: normal; white-space: break-spaces">
                {{ props.row.domain }}
              </div>
            </q-td>
          </template>
          <template v-slot:body-cell-treatment="props">
            <q-td :props="props">
              <div style="overflow-wrap: normal; word-break: normal; white-space: break-spaces">
                {{ props.row.treatment }}
              </div>
            </q-td>
          </template>
          <template v-slot:body-cell-finality="props">
            <q-td :props="props">
              <div style="overflow-wrap: normal; word-break: normal; white-space: break-spaces">
                {{ props.row.finality }}
              </div>
            </q-td>
          </template>
          <template v-slot:body-cell-taskLink="props">
            <q-td :props="props">
              <div>
                <a :href="props.row.taskLink" target="_blank">Lien</a>
              </div>
            </q-td>
          </template>
          <template v-slot:body-cell-surveySummaryLink="props">
            <q-td :props="props">
              <div>
                <a :href="props.row.surveySummaryLink" target="_blank">Lien</a>
              </div>
            </q-td>
          </template>
          <template v-slot:loading>
            <q-inner-loading showing color="primary" />
          </template>
        </q-table>
      </q-card-section>
    </q-card>

    <template #fallback> loading... </template>
  </suspense>
</template>

<style lang="scss" scoped></style>
<style lang="sass">
.my-sticky-header-table
  /* height or max-height is important */
  height: calc(100vh - 180px)
//   max-height: 600vh

  .q-table__top,
  .q-table__bottom,
  thead tr:first-child th
    /* bg color is important for th; just specify one */
    background-color: white

  thead tr th
    position: sticky
    z-index: 1
  thead tr:first-child th
    top: 0

  /* this is when the loading indicator appears */
  &.q-table--loading thead tr:last-child th
    /* height of all previous header rows */
    top: 48px

  /* prevent scrolling behind sticky top row on focus */
  tbody
    /* height of all previous header rows */
    scroll-margin-top: 48px
</style>
